import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class GuestGuard implements CanActivate {
  constructor(
    private router: Router,
    private authService: AuthService
  ) {}

  canActivate(): Observable<boolean> | Promise<boolean> | boolean {
    console.log('GuestGuard: Checking guest access');
    
    return this.authService.isLoggedIn().pipe(
      take(1),
      map(isLoggedIn => {
        console.log('GuestGuard: isLoggedIn =', isLoggedIn);
        
        if (!isLoggedIn) {
          console.log('GuestGuard: Guest access granted');
          return true;
        } else {
          console.log('GuestGuard: User already logged in, redirecting to home');
          // If user is already logged in, redirect to home
          this.router.navigate(['/home']);
          return false;
        }
      })
    );
  }
}
